export const keyUploadDataColumns = [
  {
    name: "S.No",
    cell: (row, index) => (
      <>
        <input type="hidden" value={row.uploadId} />
        <span>{index + 1}</span>
      </>
    ),
    sortable: false,
  },
  {
    name: "Date",
    selector: (row) => row.date,
    cell: (row) => (
      <span className="add-ellip">{row?.date?.split("T")[0]}</span>
    ),
    sortable: false,
  },
  {
    name: "Brand",
    selector: (row) => row.product?.brand?.brandName || "-",
    cell: (row) =>
      row.product?.brand ? (
        <span>{row.product.brand.brandName}</span>
      ) : (
        "-"
      ),
    sortable: false,
  },
  {
    name: "Product Denominations",
    selector: (row) => row.product?.productName || "-",
    cell: (row) =>
      row.product ? (
        <span>{row.product.productName}</span>
      ) : (
        "-"
      ),
    sortable: false,
  },
  {
    name: "Upload Quantity",
    selector: (row) => row.quantity,
  },
];
